import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import FeaturedSection from './components/FeaturedSection';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '西瓜视频',
      url: 'https://www.xigua-video.com/',
      description: '西瓜视频汇聚最新电影、热播电视剧和高分综艺，全部内容免费在线观看。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.xigua-video.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });
    document.head.appendChild(schema);

    const pageSchema = document.createElement('script');
    pageSchema.type = 'application/ld+json';
    pageSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '西瓜视频 - 首页',
      url: 'https://www.xigua-video.com/',
      description: '最新电影、热播电视剧、高分综艺免费在线观看',
      isPartOf: {
        '@type': 'WebSite',
        name: '西瓜视频',
        url: 'https://www.xigua-video.com/',
      },
    });
    document.head.appendChild(pageSchema);

    const faqSchema = document.createElement('script');
    faqSchema.type = 'application/ld+json';
    faqSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '西瓜视频是否需要付费？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '不需要！西瓜视频所有内容完全免费在线观看，无需任何付费会员。',
          },
        },
        {
          '@type': 'Question',
          name: '是否需要下载APP才能观看？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '不需要下载任何软件。西瓜视频支持网页端和手机端直接播放。',
          },
        },
        {
          '@type': 'Question',
          name: '视频画质如何？会卡顿吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '西瓜视频全部内容提供超清画质，最高支持4K分辨率。CDN加速技术确保播放流畅不卡顿。',
          },
        },
        {
          '@type': 'Question',
          name: '内容多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们每天都会更新最新内容，包括最新上映的电影、热播电视剧的最新集数以及各类综艺节目。',
          },
        },
        {
          '@type': 'Question',
          name: '可以在电视上观看吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '可以的！西瓜视频支持投屏功能，您可以将内容投射到智能电视上观看。',
          },
        },
      ],
    });
    document.head.appendChild(faqSchema);

    return () => {
      document.head.removeChild(schema);
      document.head.removeChild(pageSchema);
      document.head.removeChild(faqSchema);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <FeaturedSection />
        <CategoryNav />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}